<div class="message-container">
  <span> {{ this.data.message ? this.data.message : 'Oops! Something went wrong!'}}</span>
  <span class="flex-spacer"></span>
  <div class="close-button">
    <button class="dismiss-button" mat-icon-button (click)="snackBarRef.dismiss()">
      <mat-icon aria-hidden="false" aria-label="Close">close</mat-icon>
    </button>
  </div>
</div>
